/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  myBooths: []
};

export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_BOOTHS_DONE:
      return { ...state, myBooths: action.data.items };
    case AT.ITEM_DELETE_DONE:
      if (action.itemType === 'Booth') {
        return {
          ...state,
          myBooths: R.reject((s: any) => s._id === action.itemId, state.myBooths)
        };
      }

      return state;
    default:
      return state;
  }
}
